import { UserInfo } from "@/types";
import apiService from "../api.service";

const baseURL = "/extperson/api/rest/user/";

export default {
  getUserInfo() {
    return apiService.get(`${baseURL}profile`);
  },
  putUserInfo(userInfo: UserInfo) {
    return apiService.put(`${baseURL}profile`, userInfo);
  },
  getUserImage() {
    return apiService.get(`${baseURL}profile/image`, { responseType: "blob" });
  },
  postUserImage(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return apiService.post(`${baseURL}profile/image`, formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  },
};
